import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Text, Loading } from 'components/common/Elements/Elements';
import ScoreOverTime from '../ScoreOverTime/ScoreOverTime';
import ResponseOverTime from '../ResponseOverTime/ResponseOverTime';

import { charts } from '../../../helpers/configurates';
import { postRequest } from 'utils/requests';

import classes from './ChartBox.module.scss';

const ChartBox = ({ customerId }) => {
  const [chart, setChart] = useState(charts.chart[0]);
  const [chartData, setChartData] = useState([]);
  const [chartLoader, setChartLoader] = useState(true);
  const [show, setShow] = useState(false);

  const handleUnit = e => {
    setShow(false);
    setChart(e.target.value);
  };

  useEffect(() => {
    let cancelled = false;
    setChartLoader(true);
    const REQ_BODY = {
      customerId: customerId,
      chartName: chart
    };
    postRequest('/customer/satisfaction/csat/chart', REQ_BODY)
      .then(res => {
        if (!cancelled) {
          setChartData(res.body);
          setShow(true);
        }
      })
      .catch(err => {
        !cancelled && console.log(err);
      });
    setChartLoader(false);
    return () => (cancelled = true);
  }, [customerId, chart]);

  return (
    <section className={classes.box}>
      <div className={classes.list}>
        {charts.chart.map((item, ind) => {
          return (
            <label
              key={item}
              className={cn(classes.item, chart === item && classes.active)}
            >
              <Text size={4} className={classes.item_text}>
                {charts.chartLabel[ind]}
              </Text>
              <input
                className={classes.visually_hidden}
                type="radio"
                name="charts"
                value={item}
                onChange={handleUnit}
                checked={chart === item}
              />
            </label>
          );
        })}
      </div>
      <div className={classes.chart}>
        {chartLoader || chartData.length === 0 ? (
          <Loading />
        ) : (
          <>
            {chart === charts.chart[0] && (
              <ScoreOverTime data={chartData} loader={show} />
            )}
            {chart === charts.chart[1] && (
              <ResponseOverTime data={chartData} loader={show} />
            )}
          </>
        )}
      </div>
    </section>
  );
};

ChartBox.propTypes = {
  customerId: PropTypes.string
};

export default ChartBox;
